import React from 'react'

import { getSelectedPromocode } from '../../../utils/SettingsRetriever';

import TabGenerator from './TabGenerator';

import './index.scss';

export default (props) => {
    return (
        <React.Fragment>
            
            <nav className="navWrapper">
                {!getSelectedPromocode() ?  <TabGenerator onCollapse={props.onCollapse} /> : null}
            </nav>
        </React.Fragment>
    );
}
